import type {FC} from 'react';

export const LoginPosterBackground: FC = () => (
  <div
    data-slot="login-poster-background"
    aria-hidden="true"
    className="pointer-events-none absolute inset-0 bg-login-poster"
  />
);
